import React from "react";
import { Search } from "lucide-react";

interface SearchInputProps {
  placeholder?: string;
  onSearch: (query: string) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({ placeholder = "Search templates...", onSearch }) => {
  return (
    <div className="max-w-2xl mx-auto mt-12 mb-8 px-4">
      <div className="relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-navy-400" />
        <input
          type="text"
          placeholder={placeholder}
          onChange={(e) => onSearch(e.target.value)}
          className="w-full pl-12 pr-6 py-3.5 rounded-lg border border-navy-100 focus:border-navy-300 
                   focus:ring-2 focus:ring-navy-50 text-navy-900 placeholder-navy-300 
                   transition-all duration-200 shadow-sm hover:shadow-md"
        />
      </div>
    </div>
  );
};

export default SearchInput;